import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import MDBox from "../../../components/MDBox";
import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";

export default function OrganismInfo({ organismName, setOrganismName }) {
  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={organismName}
            onChange={(event) => setOrganismName(event.target.value)}
            variant="standard"
            required
            type="text"
            label="Nom"
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}

OrganismInfo.propTypes = {
  organismName: PropTypes.string.isRequired,
  setOrganismName: PropTypes.func.isRequired,
};
